import { render, staticRenderFns } from "./BaseUserPasswordIcon.vue?vue&type=template&id=02c47f47"
import script from "./BaseUserPasswordIcon.vue?vue&type=script&lang=js"
export * from "./BaseUserPasswordIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports